import { render } from "./PosLeftContent.vue?vue&type=template&id=07073f58&scoped=true&ts=true"
import script from "./PosLeftContent.vue?vue&type=script&lang=ts"
export * from "./PosLeftContent.vue?vue&type=script&lang=ts"

import "./PosLeftContent.vue?vue&type=style&index=0&id=07073f58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07073f58"]])

export default __exports__